import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { Form, Input, Button } from './styles';

function GlobalSearchBar() {
  const [query, setQuery] = useState('');
  const history = useHistory();

  function handleSubmit(e) {
    e.preventDefault();
    const q = query.trim();
    if (q.length < 2) return;
    history.push(`/busca?q=${encodeURIComponent(q)}`);
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        type="text"
        placeholder="Buscar conteúdo..."
        value={query}
        onChange={e => setQuery(e.target.value)}
      />
      <Button type="submit">
        <FaSearch />
      </Button>
    </Form>
  );
}

export default GlobalSearchBar;
